module.exports = __webpack_public_path__ + "img/Australia.2866646a.png";